export default __webpack_public_path__ + "static/media/vip-leaf-right.ab17a6eb.svg";